import { render } from "./pagination-bg.vue?vue&type=template&id=2f4a57a6"
import script from "./pagination-bg.vue?vue&type=script&lang=js"
export * from "./pagination-bg.vue?vue&type=script&lang=js"

import "./pagination-bg.vue?vue&type=style&index=0&id=2f4a57a6&lang=less"

import exportComponent from "F:\\code\\flash-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__